import Updateprofile from "../Components/Frontend/Update_profile";

const snackConst = {};
const otpRegex = /^\d{6}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex =
  /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;

const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

const endPoints = {
  // Authentication Endpoints
  userCreate: "/user/create",
  userLogin: "/user/login",
  userChagePassward: "/user/change-password",
  userUpdate: "/user/update",
  userOTP: "/user/send-code",
  userForgetPassword: "/user/forget-password",
  userSendCode: "/user/send-code",

  //register

  // userRigester: "/user/send-code",
  userOtp: "/user/register",
  Updateprofile: "/user/update",
  userDetails: "/user/get-detail",
  updateSubscription: "/user/update-subscription",
  deleteAccount: "/user/delete",
  //stripe

  cardSave: "/user/save-card",
  cardRemove: "/user/remove-card",
  fetchCards: "/user/fetch-save-cards",

  userPayment: "/user/purchase-stripe-subscription",
  userCheckEligibility: "/user/check-eligibility",

  cancelSubscription: "/user/cancel-stripe-subscription",

  //Story Genrater

  storyGenrater: "/user/story/generate",
  storyDelete: "/user/story/delete",
  //saveHistory

  saveHistory: "/user/story/save",
  getAllHistory: "/user/story/get-all",
  // Users Endpoints

  getAllSubscriptions: "/subscription/get-all-active",

  // home Endpoints
  fetchHomedata: "/admin/story-input/get-home",

  //tips
  getTips: "/admin/setting/get",
};

export {
  emailRegex,
  passwordRegex,
  otpRegex,
  requestType,
  endPoints,
  snackConst,
};
